var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPieChart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6749 13.2417C17.1448 14.4955 16.3156 15.6002 15.2598 16.4595C14.2041 17.3187 12.9539 17.9063 11.6186 18.1707C10.2833 18.4352 8.90361 18.3685 7.60005 17.9766C6.29649 17.5846 5.10878 16.8793 4.14078 15.9223C3.17277 14.9653 2.45394 13.7857 2.04712 12.4867C1.64031 11.1877 1.5579 9.80881 1.80709 8.47059C2.05629 7.13238 2.62951 5.87559 3.47663 4.81009C4.32376 3.74459 5.419 2.90283 6.6666 2.3584",
    stroke: "#212945",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 10.0001C18.3333 8.90573 18.1178 7.8221 17.699 6.81105C17.2802 5.80001 16.6664 4.88135 15.8926 4.10752C15.1187 3.3337 14.2001 2.71987 13.189 2.30109C12.178 1.8823 11.0943 1.66675 10 1.66675V10.0001H18.3333Z",
    stroke: "#212945",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart);
export default __webpack_public_path__ + "static/media/pie-chart.3a7835343679d55b10fa1bea7eb5ebe5.svg";
export { ForwardRef as ReactComponent };